<template>
  <div>
    <el-row class="m-b15 flex-ac flex p-lr20">
      <el-col :span="10" class="flex flex-ac">
        <span class="f-14" style="display: inline-block;width: 90px;">查询条件：</span>
        <el-input
          v-model="keyword"
          size="medium"
          placeholder="申请编号、交易编号、买家客户"
        ></el-input>
      </el-col>
      <el-col :span="1"></el-col>
      <el-col :span="12">
        <span class="f-14">申请时间：</span>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          size="medium"
          range-separator="-"
          value-format="timestamp"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-col>
    </el-row>
    <div class="p-lr20">
      <el-button size="medium" type="primary" @click="loadData">查询</el-button>
      <el-button size="medium" type="primary" @click="reset">重置</el-button>
      <el-button size="medium" @click="exportData">批量导出</el-button>
      <el-button size="medium" @click="showImport = true">导入开票信息</el-button>
      <el-button size="medium" @click="showImportRecord = true">查看导入记录</el-button>
    </div>
    <div class="p-20 c-9 f-14">已申请开票总金额: &nbsp;{{ totalAmount | currencyFormat }}</div>
    <el-table :data="dataList" @selection-change="selectChange">
      <el-table-column type="selection" width="60"> </el-table-column>
      <el-table-column label="序号" type="index" align="center" width="50"></el-table-column>
      <el-table-column label="申请编号" prop="invoiceApplyCode" align="center" width="250">
        <template v-slot="{ row }">
          <el-button type="text" @click="viewDetail(row.id)">{{ row.invoiceApplyCode }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="发票抬头" prop="buyerOrgName" align="center"></el-table-column>
      <el-table-column label="开票状态" prop="status" align="center">
        <template v-slot="{ row }">
          <div>{{ row.status | convertStatus }}</div>
        </template>
      </el-table-column>
      <el-table-column label="吨数" prop="totalWeight" align="center">
        <template v-slot="{ row }">
          <div>{{ row.totalWeight | formatWeightWithUnit }}</div>
        </template>
      </el-table-column>
      <el-table-column label="开票金额" prop="totalAmount" align="center">
        <template v-slot="{ row }">
          <div>{{ row.totalAmount | currencyFormat }}</div>
        </template>
      </el-table-column>
      <el-table-column label="税额" prop="totalTaxAmount" align="center">
        <template v-slot="{ row }">
          <div>{{ row.totalTaxAmount | currencyFormat }}</div>
        </template>
      </el-table-column>
      <el-table-column label="发票类型" prop="invoiceType" align="center">
        <template v-slot="{ row }">
          <div>{{ row.invoiceType | convertInvoiceType }}</div>
        </template>
      </el-table-column>
      <el-table-column label="申请人" prop="applyName" align="center">
        <template v-slot="{ row }">
          <div>{{ row.applyName | convertEmpty }}</div>
        </template>
      </el-table-column>
      <el-table-column label="申请时间" prop="gmtCreated" align="center" width="100">
        <template v-slot="{ row }">
          <div>{{ row.gmtCreated | formatTime('{y}-{M}-{d} {h}:{m}:{s}') }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template v-slot="{ row }">
          <el-button type="text" @click="viewDetail(row.id)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      class="page"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNum"
      :page-size="pageSize"
      :total="totalNum"
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>

    <el-dialog :visible="showImport" title="导入开票信息" @close="closeImport">
      <div class="m-b15">提交开票信息后，开票状态将变为已开票。</div>
      <div class="flex m-b15" style="align-items: baseline">
        <el-upload
          ref="upload"
          :action="UPLOAD_ROOT"
          :on-success="handleSuccess"
          :data="uploadData"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
          :on-remove="handleRemove"
          :multiple="false"
          :file-list="fileList"
          :before-upload="beforeUpload"
        >
          <el-button type="primary">点击上传</el-button>
        </el-upload>
        <el-button class="m-l20" @click="downloadTemplate">点击下载模板</el-button>
      </div>
      <div class="m-b15">请下载模板，按照模板填写要导入的内容。</div>
      <div>在上传文件完成后，再点击确定开始导入。</div>

      <template #footer>
        <el-button @click="closeImport">取消</el-button>
        <el-button type="primary" @click="startImport">确认已开票</el-button>
      </template>
    </el-dialog>

    <invoice-record :visible.sync="showImportRecord"></invoice-record>
  </div>
</template>

<script>
import { UPLOAD_ROOT, FILE_ROOT } from '@/common/constants/'
import { FILE_ACCESS_PRIVATE } from '@/common/constants/index'
import { getWebToken } from '@/common/utils/common'
import InvoiceRecord from './components/import-record'

export default {
  components: {
    InvoiceRecord
  },
  data() {
    return {
      showImportRecord: false,
      UPLOAD_ROOT,
      selection: [],
      dateRange: '',
      dataList: [],
      totalNum: 0,
      totalAmount: 0,
      keyword: '',
      pageNum: 1,
      pageSize: 10,
      showImport: false,
      importParams: {},
      fileList: [],
      uploadData: {
        _fs: 1,
        _tk: getWebToken(),
        _aid: 4
      }
    }
  },
  created() {
    this.loadData()
  },
  filters: {
    // 开票申请单状态
    convertStatus(status) {
      let statuses = {
        '1': '待开票',
        '2': '已开票'
      }
      return statuses[status] ? statuses[status] : ''
    },
    // 发票类型
    convertInvoiceType(type) {
      let types = {
        '1': '增值税专用发票',
        '2': '增值税普通发票'
      }
      return types[type] ? types[type] : ''
    },
    convertEmpty(content) {
      return content ? content : '-'
    }
  },
  methods: {
    async loadData() {
      let param = {
        status: 1,
        pageSize: this.pageSize,
        pageNo: this.pageNum
      }
      if (this.keyword) {
        param.orderNoOrBuyerOrgName = this.keyword
      }
      if (this.dateRange.length > 0) {
        param.startApplyDate = this.dateRange[0]
        param.endApplyDate = this.dateRange[1] + (60 * 60 * 24 - 1) * 1000
      }

      let { success, data } = await this.$post('invoice.seller.queryInvoiceApply', {
        request: param
      })
      if (success) {
        let {
          totalNum: total = 0,
          allTotalAmount: totalAmount = 0,
          sellerInvoiceApplyVOList: dataList = []
        } = data[0]
        this.totalNum = total
        this.totalAmount = totalAmount
        this.dataList = dataList
      }
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.loadData()
    },
    handleCurrentChange(pageNo) {
      this.pageNum = pageNo
      this.loadData()
    },
    viewDetail(id) {
      this.$router.push({ path: 'invoice-detail/' + id })
    },
    selectChange(val) {
      this.selection = val
    },
    async exportData() {
      if (this.selection.length > 0) {
        let keys = this.selection.map(i => i.id)
        let { success, data } = await this.$post('invoice.seller.exportApply', {
          request: { checkedIds: keys }
        })
        if (success) {
          this.downloadFile(data[0].fileKey)
        }
      } else {
        this.$message.warning('您必须先选择要导出的申请单')
      }
    },
    reset() {
      this.pageNum = 1
      this.pageSize = 10
      this.selection = []
      this.keyword = ''
      this.dateRange = []
      this.loadData()
    },
    downloadFile(key) {
      let url = `${FILE_ACCESS_PRIVATE}${key}&_tk=${getWebToken()}`
      this.download(url, key)
    },
    downloadOpenFile(key) {
      let url = `${FILE_ROOT}${key}`
      this.download(url, key)
    },
    download(url, name) {
      try {
        let downloadElement = document.createElement('a')
        downloadElement.download = name
        downloadElement.href = url
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement)
      } catch (err) {
        console.log(err)
      }
    },
    closeImport() {
      this.showImport = false
      this.$refs.upload.clearFiles()
    },
    async downloadTemplate() {
      let { success, data } = await this.$post('invoice.seller.downloadInvoiceTemplate')
      if (success) {
        this.downloadOpenFile(data[0].templateFileKey)
      }
    },
    beforeUpload(file, fileList) {
      const isXls =
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.type === 'application/vnd.ms-excel' ||
        !file.type
      if (!isXls) {
        this.$message.error('上传文件只能是excel!')
        return false
      }
      return isXls
    },
    handleRemove() {
      this.importParams.fileName = ''
      this.importParams.fileKey = ''
    },
    handleSuccess(response, file, fileList) {
      this.importParams.fileName = file.name
      this.importParams.fileKey = file.response.data
      this.fileList = [
        {
          name: file.name
        }
      ]
    },
    async startImport() {
      if (this.importParams.fileKey) {
        let { success, data } = await this.$post('invoice.seller.importInvoiceForExcel', {
          request: {
            fileKey: this.importParams.fileKey,
            fileName: this.importParams.fileName
          }
        })
        if (success && data[0].value) {
          this.$message.success('导入已开始，请查看导入记录获取最新状态')
        } else {
          this.$message.error('导入操作失败')
        }
        this.closeImport()
      } else {
        this.$message.warning(
          '必须先上传文件才可以开始导入。如果上传的文件还在显示进度条，请耐心等待上传完成哦。'
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  text-align: right;
  margin-top: 20px;
}
</style>
